import ProjectStatusBar from './ProjectStatusBar'

export default ProjectStatusBar
